module.exports = "/images/ROGERIO_JOSE_GOMES_CARDOSO.jpg?4fc6cce2bed79b019702cb34a37bdb2e";